import React, { Component } from "react";

import FlatButton         from "material-ui/FlatButton";

import "../CSS/style_Index2.css"

import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
import * as ROUTE from "../Utils/Strings/Route";
import TabellaSpecifiche from "../Components/component_TabellaSpecifiche";
import "../CSS/style_ExplanationPage.css";

import { Grid, Row, Col } from "react-material-responsive-grid";

import IconDone         from "material-ui/svg-icons/action/done"
import IconDoneAll      from "material-ui/svg-icons/action/done-all"
import IconClear        from "material-ui/svg-icons/content/clear"

import { LABEL_DownloadNow, LABEL_SignInNow } from "../Utils/Strings/Labels";

import { LINK_PLAY_STORE } from "../Utils/Strings/URL";

export default class SchermataSpecifiche extends Component {
  constructor(props) {
    super(props);

    this.state = {
        
    }
  }


  render() {
    const iconList = 
    [
        <IconClear   style = { { fontSize : "20px", color : "red" } } />,
        <IconDone    style = { { fontSize : "20px", color : "#00FF00" } } />,
        <IconDoneAll style = { { fontSize : "20px", color : "green" } } />
    ]

    var USERLANGUAGE = this.props.Language;
    return(
        <div style={{marginBottom: "100px"}}>
            <div className="sg-grid sg-versione">
                

                <div className="sg-item sg-versione"  onClick={() => window.location.href = LINK_PLAY_STORE}>
                    <TabellaSpecifiche
                        List = {["free", 2, 1, 1, 1, 0, 0, 1, 0, 0, "  Gratis"]}
                        Icons = {iconList}
                        Language = {USERLANGUAGE}
                    />
                    <div className="sg-item-details">
                        Scarica Ora
                    </div>
                </div>

                <div className="sg-item sg-versione"  onClick={()=>PAGESSWITCH.gotoPageWithParams(ROUTE.SignIn)}>
                    <TabellaSpecifiche
                        List = {["pro", 2, 2, 2, 2, 2, 2, 2, 0, 0, " 100,00 €"]}
                        Icons = {iconList}
                        Language = {USERLANGUAGE}
                    />
                    <div className="sg-item-details">
                        Registrati
                    </div>
                </div>

                <div className="sg-item sg-versione"  onClick={()=>PAGESSWITCH.gotoPageWithParams(ROUTE.SignIn)}>
                    <TabellaSpecifiche
                        List = {["cloud", 2, 2, 2, 2, 2, 2, 2, 2, 2, " 100,00 €/A"]}
                        Icons = {iconList}
                        Language = {USERLANGUAGE}
                    />
                    <div className="sg-item-details">
                        Registrati
                    </div>
                </div>
                
            </div>

            <div className="sg-legenda-container">
                <div className="sg-legenda" >
                    <Grid>
                        <Row>
                            <Col xs4={2} sm12={2} lg12={2} style={{marginLeft : "10px", marginRight: "10px"}}>Legenda</Col>
                            <Col xs4={2} sm12={3} lg12={3} style={{marginLeft : "10px", marginRight: "10px"}}>{iconList[0]} Non Disponibile</Col>
                            <Col xs4={2} sm12={3} lg12={3} style={{marginLeft : "10px", marginRight: "10px"}}>{iconList[1]} Solo Uno Settaggio</Col>
                            <Col xs4={2} sm12={3} lg12={3} style={{marginLeft : "10px", marginRight: "10px"}}>{iconList[2]} Piu' Di Un Settaggio</Col>
                        </Row>
                    </Grid>
                </div>
            </div>

            
            <div className="ex-pages-container">
                <div className="ex-pages">
                    <div className="ex-title">
                        {"Bilapp Free"}
                    </div>
                    <div className="ex-body">
                        Pensata per chi volesse gestire facilmente le proprie bilance semplicemente utilizzando il proprio smartphone.<br/>
                        Se hai bisogno anche tu di gestire facilmente tutte le tue bilance della Serie Diade o Dialogic della coop. Bilanciai scarica ora la versione Free.
                        <FlatButton
                          className="btn-bottom"
                          label={LABEL_DownloadNow[USERLANGUAGE]}
                          fullWidth={true}
                          style={{marginTop: "20px"}}
                          onClick={() => window.location.href = LINK_PLAY_STORE } />
                    </div>
                </div>

                <div className="ex-pages">
                    <div className="ex-title">
                        {"Bilapp Pro"}
                    </div>
                    <div className="ex-body">
                        Oltre a gestire tutte le tue bilance, la versione Pro di BilApp ti offre la possibilita di aggiungere dei campi personalizzati alle tue pesate, di aggiungere piu di un aziende e a quest'ultima associargli altrettanti impianti e bliance.
                        <FlatButton
                          className="btn-bottom"
                          label={LABEL_SignInNow[USERLANGUAGE]}
                          fullWidth={true}
                          style={{marginTop: "20px"}}
                          onClick={()=>PAGESSWITCH.gotoPageWithParams(ROUTE.SignIn)} />
                    </div>
                </div>

                <div className="ex-pages">
                    <div className="ex-title">
                        {"Bilapp Cloud"}
                    </div>
                    <div className="ex-body">
                        Condivisione. Oltre ad offrire tutte le funzionalita' che si possono trovare nelle versioni Free e Pro, il punto di forza della versione Cloud e' la condivisione <b>totale</b> e in <b>tempo reale</b> di tutti i tuoi dati.
                        
                        <FlatButton
                          className="btn-bottom"
                          label={LABEL_SignInNow[USERLANGUAGE]}
                          fullWidth={true}
                          style={{marginTop: "20px"}}
                          onClick={()=>PAGESSWITCH.gotoPageWithParams(ROUTE.SignIn)} />
                    </div>
                </div>
            </div>
                
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/component_SchermataSpecifiche.js